import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { CmsApiService } from 'src/app/services/api/cms.api.service';

@Component({
  selector: 'faq-screen',
  templateUrl: `./faq.screen.html`,
  styleUrls: ['./faq.screen.scss'],
})
export class FaqScreenComponent implements OnInit {
  @ViewChild('faq') faq: ElementRef;

  private iframeSrc = '';
  private called = false;

  constructor(private cmsApi: CmsApiService) {}

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    this.cmsApi.mystatusChanged.subscribe(() => {
      this.updatedStatus();
      this.called = true;
    });
    if (!this.called) {
      this.updatedStatus();
    }
  }

  private updatedStatus() {
    this.iframeSrc = this.cmsApi.getFaqCMSUrl();
    this.faq.nativeElement.setAttribute('src', this.iframeSrc);
  }
}
